import { ExportSquare, Trash } from 'iconsax-react';
import styled, { css } from 'styled-components';

interface IconProps {
  disabled?: boolean;
}

export const Container = styled.div`
  gap: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FileNameContainer = styled.a`
  width: 100%;
  gap: 12px;
  display: flex;
  align-items: center;
  padding: 14px 24px;
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: ${({ theme }) => theme.colors.white.two};
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export const FileName = styled.span`
  color: ${({ theme }) => theme.colors.info};
  font-size: ${({ theme }) => theme.fontSize.small};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

export const OpenInNewIcon = styled(ExportSquare)`
  color: ${({ theme }) => theme.colors.info};
  font-size: ${({ theme }) => theme.fontSize.medium};
`;

export const DeleteIcon = styled(Trash)<IconProps>`
  margin-left: 8px;
  width: fit-content;
  color: ${({ theme }) => theme.colors.error};
  font-size: ${({ theme }) => theme.fontSize.large};

  ${({ disabled }) =>
    disabled
      ? css`
          cursor: not-allowed;
        `
      : css`
          cursor: pointer;
          &:hover {
            opacity: 0.7;
          }
        `}
`;
